import React, { useEffect, useState } from "react";
import AddIcon from "@material-ui/icons/Add";
import { Button } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import ShowcaseCard from "./ShowcaseCard";
import BookDataService from "../../services/BookService";

import ManageShowcaseModal from "./ManageShowcaseModal";

import "./ShowcaseList.css";

//loader
import { css } from "@emotion/react";
import SyncLoader from "react-spinners/SyncLoader";
import ShowcaseService from "../../services/ShowcaseService";
import CreateNewShowcaseModal from "./CreateNewShowcaseModal";

const override = css`
  position: abolute;
  left: vh;
`;

const loadingColor = "#8C9BD8";

const ShowcaseList = (props) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showcases, setShowcases] = useState([]);
  const [allShowcases, setAllShowcases] = useState([]);
  const [selectedShowcase, setSelectedShowcase] = useState(null);
  const [allBooks, setAllBooks] = useState();

  const [newShowcaseModalOpen, setNewShowcaseModalOpen] = useState(false);

  //loading
  const [loading, setLoading] = useState(true);

  const [getAllListener, setGetAllListener] = useState(0);

  useEffect(() => {
    ShowcaseService.getAll()
      .then((res) => {
        setShowcases(res.data.showcases);
        setAllShowcases(res.data.showcases);
        setLoading(false);
      })
      .catch((e) => {
        console.log("Error getting showcases:", e);
        setLoading(false);
      });

    BookDataService.getAll()
      .then((res) => {
        setAllBooks(res.data);
      })
      .catch((e) => {
        console.log("Error getting all books:", e);
      });
  }, [getAllListener]);

  const refreshShowcases = () => {
    setGetAllListener(() => getAllListener + 1);
  };

  const clearSearchBar = () => {
    setSearchQuery("");
  };

  useEffect(() => {
    setShowcases(
      allShowcases.filter((s) => {
        return s.title.toLowerCase().includes(searchQuery.toLowerCase());
      })
    );
  }, [searchQuery]);

  return loading ? (
    <div className="showcase-list-container">
      <SyncLoader color={loadingColor} loading={loading} css={override} style={{ marginLeft: "auto auto" }} />
    </div>
  ) : (
    <div className="showcase-list">
      <h1>Showcases</h1>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <div className="add-showcase-button">
          <Button
            color="primary"
            variant="contained"
            onClick={() => setNewShowcaseModalOpen(true)}
            startIcon={<AddIcon />}
          >
            New showcase
          </Button>
        </div>
        <div className="showcase-searchbar">
          <span>Search showcases:&nbsp;</span>
          <input
            type="text"
            value={searchQuery}
            style={{ marginRight: "0.25rem" }}
            onChange={(e) => {
              setSearchQuery(e.target.value);
            }}
          />
          <div className="clear-icon">
            <ClearIcon className={"clear-icon"} onClick={clearSearchBar} />
          </div>
        </div>
      </div>
      <div className="showcase-cards">
        {showcases && showcases.length ? (
          showcases.map((s, i) => {
            return (
              <ShowcaseCard
                key={s.id}
                id={s.id}
                name={s.title}
                pin={s.pin}
                bannerURL={s.bannerUrl}
                openModal={() => setModalOpen(true)}
                setSelected={() => setSelectedShowcase(s)}
                refreshShowcases={refreshShowcases}
              />
            );
          })
        ) : (
          <h4 style={{ textAlign: "center" }}>No showcases... Create one!</h4>
        )}
      </div>
      <ManageShowcaseModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        showcase={selectedShowcase}
        allBooks={allBooks}
      />
      <CreateNewShowcaseModal
        isOpen={newShowcaseModalOpen}
        setIsOpen={setNewShowcaseModalOpen}
        setLoading={setLoading}
        refreshShowcases={refreshShowcases}
      />
    </div>
  );
};

export default ShowcaseList;
